<template>
  <div>
    <TopList
      ref="TopList"
      @setType="setType"
      :navList="['用户管理', '用户组管理']"
    ></TopList>
    <div id="sonUser">
      <!--    <div class="title">-->
      <!--      <div @click="setIndex(0)" class="titleItem">-->
      <!--        用户管理-->
      <!--        <span :class="index === 0 ? 'active' : ''"></span>-->
      <!--      </div>-->
      <!--      <div @click="setIndex(1)" class="titleItem">-->
      <!--        用户组管理-->
      <!--        <span :class="index === 1 ? 'active' : ''"></span>-->
      <!--      </div>-->
      <!--    </div>-->
      <div class="content">
        <UserList @setTypeC="setTypeC" v-if="type === 0"></UserList>
        <UserGroupList @setTypeC="setTypeC" v-if="type === 1"></UserGroupList>
      </div>
    </div>
  </div>
</template>

<script>
import TopList from "../../components/topList";
import UserList from "./components/userList";
import UserGroupList from "./components/userGroupList";
export default {
  name: "index",
  data() {
    return {
      type: 0,
    };
  },
  components: {
    UserGroupList,
    UserList,
    TopList,
  },
  methods: {
    setType(num) {
      if (num === 0) {
      }
      this.type = num;
    },
    setTypeC(num) {
      this.type = num;
      this.$refs.TopList.act = num;
    },
  },
};
</script>

<style lang="scss" scoped>
#sonUser {
  width: 1200px;
  height: 751px;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 30px;
  padding-top: 32px;
  .content {
    margin-left: 56px;
    margin-top: 50px;
  }
  .title {
    width: 280px;
    justify-content: space-between;
    //background: pink;
    margin-left: 56px;
    height: 32px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    //background: yellow;
    display: flex;

    .titleItem {
      position: relative;
      .active {
        position: absolute;
        width: 50px;
        height: 6px;
        background: #4064e1;
        left: 20px;
        border-radius: 3px;
        bottom: -20px;
        display: block;
      }
    }
  }
}
</style>
